import { jsx as W } from "@emotion/react/jsx-runtime";
import { useRef as u, useEffect as A } from "react";
import r from "prop-types";
import { css as R } from "@emotion/react";
import { COLORS_RAW as p } from "../../../constants.mjs";
import w from "./WaveformPainter.mjs";
const y = 1600, O = 35, v = "#414141", g = {
  canvas: (e) => R`
        width: 100%;
        height: ${e}px;
    `
}, c = ({
  waveformData: e,
  fillColor: a = v,
  strokeColor: f = v,
  progressColor: o = p.WHITE,
  highlightColor: m = p.GRAY_2,
  onLoad: t,
  height: i = O,
  onClick: l
}) => {
  const n = u(null), s = u(null);
  return A(() => {
    n.current && (s.current = new w(
      n.current,
      e || Array(1e3),
      a,
      f,
      o,
      m
    ), s.current.clear(), s.current.drawWaveform(), t == null || t(s.current));
  }, [a, o, f, m, e, t]), /* @__PURE__ */ W(
    "canvas",
    {
      id: "waveform-canvas",
      ref: n,
      width: y,
      height: i,
      css: g.canvas(i),
      onClick: l
    }
  );
};
c.displayName = "Waveform";
c.propTypes = {
  waveformData: r.arrayOf(r.number),
  fillColor: r.string,
  strokeColor: r.string,
  progressColor: r.string,
  highlightColor: r.string,
  onLoad: r.func.isRequired,
  height: r.number,
  onClick: r.func
};
const d = c;
export {
  d as default
};
